export default __webpack_public_path__ + "static/media/icon-warn.9c29314e.svg";